import React, { useEffect, useState } from "react";
import { useSelector, connect, useDispatch } from "react-redux";
import DisplayBox from "../../hoc/DisplayBox/DisplayBox";
import {
  REPORT,
  ACTIVITY_LOG_EVENT_TYPE,
  ACTIVITY_LOG_SELECT_MAP_REVERSED,
  SERVICE_NOW,
  CREATE_SERVICE_NOW,
  EDIT_SERVICE_NOW,
  DETAILS_SERVICE_NOW,
  SEARCH_SERVICE_NOW,
  SESSION_READONLYUSER,
  AUTO_COMPLETE_SELECT_ENABLE,
  ACCOUNT_ADMIN,
  INCIDENT_FORM_ENABLED,
  SERVICENOW_REASONS,
  SESSION_SUPERUSER,
} from "../../shared/Constants";
import Button from "../../UI/Button/Button";
import { setSearchState } from "../../store/actions/reporting";
import * as actions from "../../store/actions/index";
import { isStartDateGreaterThenEndDate } from "../../shared/utility";
import Input from "../../UI/Input/Input";
import { checkValidity, compareDates } from "../../shared/utility";
import Spinner from "../../UI/Spinner/Spinner";
import classes from "./ServiceNow.css";
import { getTargetUrlDropDownSortedList } from "../../shared/utility";
import Basics from "../Member/EnableDisable/basics/Basics";
import Description from "../Member/EnableDisable/Description/Description";
import CallerDetails from "../Member/EnableDisable/CallerDetails/CallerDetails";
import ImpactedMember from "../Member/EnableDisable/ImpectedMember/ImpactedMember";
import Reporter from "../Member/EnableDisable/reporter/Reporter";
import IncidentDetails from "../Member/EnableDisable/IncidentDetails/IncidentDetails";
import Message from "../../components/Message/Message";
import Modal from "../../UI/Modal/Modal";

const ServiceNowContainer = (props) => {
  const [message, setMessage] = useState("");
  const dispatch = useDispatch();
  const { formType } = props;
  const showSpinner = useSelector((state) => state.reporting.showSpinner);

  const [statusFormValid, setStatusFormValid] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchFormState, setSearchFormState] = useState({
    quickSearchKeyword: {
      elementType: "input",
      elementConfig: {
        type: "text",
        id: "quickSearchKeyword",
        placeholder: "search",
        maxLength: 101,
      },
      value: "",
      validation: {
        required: false,
        minlength: 2,
        maxlength: 100,
        nospace: true,
        specialchar: [
          "<",
          '"',
          ":",
          ";",
          "=",
          "\\",
          "*",
          "&",
          "(",
          ")",
          "#",
          ",",
        ],
      },
      valid: false,
      touched: false,
      label: null,
      quickSearchInput: true,
      inputType: "QuickSearch",
    },
  });
  const errorHandler = (error) => {
    props.setError(error);
  };
  const [targetPortal, setTargetPortal] = useState("");
  const [reason, setReason] = useState("");
  const [incidentTicket, setIncidentTicket] = useState("");
  const [descriptionDetails, setDescriptionDetails] = useState({});
  const [reporterDetails, setReporterDetails] = useState({});
  const [callerDetails, setCallerDetails] = useState({});
  const [basicDetails, setBasicDetails] = useState({});
  const [reporterFormValid, setReporterFormValid] = useState(false);
  const [basicFormValid, setBasicFormValid] = useState(false);
  const [descriptionValid, setDescriptionValid] = useState(false);
  const [callerDetailsValid, setCallerDetailsValid] = useState(false);
  const [enableDisableValid, setEnableDisableValid] = useState(false);
  const [resetValues, setResetValues] = useState(false);

  const reasonList = useSelector((state) => state.member.disableReasons);
  const reasonFailure = useSelector((state) => state.member.getReasonFailure);

  const isSaveButtonDisabled = () => {
    if (props.disabledMember && incidentTicket) {
      setEnableDisableValid(true);
    } else if (incidentTicket === "") {
      setEnableDisableValid(false);
    } else if (reason === "") {
      setEnableDisableValid(false);
    } else if (targetPortal === "") {
      setEnableDisableValid(false);
    } else if (incidentTicket !== "" && reason !== "" && targetPortal !== "") {
      setEnableDisableValid(true);
    }
  };

  const createRequest = (
    incTicket,
    info,
    reason,
    portalShortNm,
    rsnTypCd,
    portalVersion
  ) => {
    const memberEsso =
      props.memberEsso ??
      (props.incidentMembersList && props.incidentMembersList[0]?.essoData) ??
      {};
    let userData = {
      healthSafeId: memberEsso.uuid,
      empMsId: props.user.userLoginId,
      createdBy: props.user.userLoginId,
      reason: descriptionDetails.reason.value,
      incidentNumber: props.impactedMemberData
        ? props.impactedMemberData.incidentNumber
        : incTicket,
      portalShortName: props.impactedMemberData
        ? props.impactedMemberData.prtlShrtNm
        : callerDetails.targetPortal.value,
      reasonTypeCode: props.impactedMemberData
        ? props.impactedMemberData.reasonTypeCode
        : rsnTypCd,
      newAPI: true,
    };

    // report details
    const reportersDateTime = props.impactedMemberData
      ? props.impactedMemberData.reporterTs
      : new Date(
          `${reporterDetails.date?.value}T${reporterDetails.time?.value}Z`
        );
    userData = {
      ...userData,
      ...{
        reporterEmail: props.user.agentEmailId,
        assignedTo: reporterDetails.assignedTo?.value,
        reporterTs: reportersDateTime,
        reporterTimeZone: props.impactedMemberData
          ? props.impactedMemberData.reporterTimeZone
          : reporterDetails.timeZone?.value,
      },
    };

    //basic details
    const basicsDateTime = props.impactedMemberData
      ? props.impactedMemberData.issueOccurredTs
      : new Date(`${basicDetails.date?.value}T${basicDetails.time?.value}Z`);
    userData = {
      ...userData,
      ...{
        priority: Number(basicDetails.priority?.value+''),
        issueOccurredTs: basicsDateTime,
        issueOccurredTimeZone: props.impactedMemberData
          ? props.impactedMemberData.issueOccurredTimeZone
          : basicDetails.timeZone?.value,
      },
    };

    // caller details
    userData = {
      ...userData,
      ...{
        callerFirstName: props.impactedMemberData
          ? props.impactedMemberData.callerFirstName
          : callerDetails.firstName?.value,
        callerLastName: props.impactedMemberData
          ? props.impactedMemberData.callerLastName
          : callerDetails.lastName?.value,
        callerPhone: props.impactedMemberData
          ? props.impactedMemberData.callerPhone
          : `${callerDetails.countryCode?.value ?? 1}${
              callerDetails.phone?.value
            }`,
        callerEmail: props.impactedMemberData
          ? props.impactedMemberData.callerEmail
          : callerDetails.email?.value,
      },
    };

    // member details
    userData = {
      ...userData,
      memberInfo: {
        firstName: props.impactedMemberData
          ? props.impactedMemberData.callerFirstName
          : callerDetails.firstName?.value,
        lastName: props.impactedMemberData
          ? props.impactedMemberData.callerLastName
          : callerDetails.lastName?.value,
        memberSubscriberId: callerDetails.memberId?.value,
        username: callerDetails.username?.value,
        ssn: callerDetails.ssn?.value,
      },
    };

    // impacted member list data
    let impactedMemberList = [];

    for (let impactedMember in props.incidentMembersList) {
      if (
        props.incidentMembersList[impactedMember]?.essoData?.essoStatus
          ?.enableDisableStatus === "enabled"
      ) {
        impactedMemberList.push({
          healthSafeId:
          props.incidentMembersList[impactedMember]?.member && props.incidentMembersList[impactedMember]?.member[0].healthSafeId ||
          (props.incidentMembersList[impactedMember]?.essoData?.uuid),
          memberType:
            props.incidentMembersList[
              impactedMember
            ]?.priImpactedFlag?.toUpperCase(),
          username: props.incidentMembersList[impactedMember]?.essoData?.userName,
          actionRequested: "CREATE_SERVICE_NOW_INCIDENT",
          createdBy: props.user.userLoginId,
        });
      }
    }
    userData = {
      ...userData,
      incidentMemberActionRequests: impactedMemberList,
    };
    const disableReasons = JSON.parse(localStorage.getItem(SERVICENOW_REASONS));
    const selectedReason = disableReasons?.filter(
      (reason) => reason.reason === descriptionDetails.reason.value
    );
    // description details
    userData = {
      ...userData,
      issueDescription: props.impactedMemberData
        ? props.impactedMemberData.issueDescription
        : descriptionDetails.reason.value,
      reasonTypeCode: selectedReason?.[0]?.reasonTypeCode,
    };

    return userData;
  };

  const validateForm = () => {
    const invalidFields = [];
    Object.keys(descriptionDetails).map((key) => {
      if (!descriptionDetails[key].valid) {
        invalidFields.push(descriptionDetails[key].label);
      }
    });
    Object.keys(basicDetails).map((key) => {
      if (!basicDetails[key].valid) {
        invalidFields.push(basicDetails[key].label);
      }
    });
    if (!callerDetails["targetPortal"]?.valid) {
      invalidFields.push("Target Portal");
    }
    let callerIssues = false;
    let impactedMemberIssues = false;
    if (
      !props.incidentMembersList ||
      (props.incidentMembersList && props.incidentMembersList.length === 0)
    ) {
      // invalidFields.push("Impacted Members");
      impactedMemberIssues = true;
    }
    if (
      !callerDetails["firstName"]?.valid ||
      !callerDetails["lastName"]?.valid ||
      (!callerDetails["email"]?.valid && (!callerDetails["phone"]?.valid || !callerDetails["countryCode"]?.valid))
    ) {
      // invalidFields.push("Target Portal");
      callerIssues = true;
    }
    if (callerIssues && impactedMemberIssues) {
      invalidFields.push("Caller details");
    }
    let tempMessage = "";
    if (invalidFields.length > 0) {
      tempMessage = invalidFields.join(", ");
      tempMessage += ` field${
        invalidFields.length > 1 ? "s are" : " is"
      } invalid.`;
    }
    setMessage(tempMessage);
    return tempMessage;
  };

  const createIncidentHandler = (eventR) => {
    eventR.preventDefault();
    if (validateForm()) {
      window.scrollTo({
        top: 0,
      });
      return;
    }
    let userData = createRequest();
    // console.log("create incident button clicked", userData);
    dispatch(actions.createIncident(userData));
  };

  useEffect(() => {
    if (props.apiErroMsg || props.incidentNumber) {
      window.scrollTo({
        top: 0,
      });
    }
  }, [props.apiErroMsg, props.incidentNumber]);

  const clearSearch = () => {
    setMessage("")
    setResetValues(!resetValues);
    props.resetIncidentMembersList([]);
    props.resetIncidentDetails();
  };

  const createForm = () => {
    return (
      <form onSubmit={createIncidentHandler}>
        {props.incidentNumber && (
          <IncidentDetails formDisabled={props.incidentNumber && !formType} />
        )}
        <Reporter
          isValid={setReporterFormValid}
          setReporterDetails={setReporterDetails}
          formDisabled={props.incidentNumber && !formType}
        />
        <Basics
          isValid={setBasicFormValid}
          setBasicDetails={setBasicDetails}
          formDisabled={props.incidentNumber && !formType}
          resetValues={resetValues}
        />
        <Description
          isValid={setDescriptionValid}
          setDescriptionDetails={setDescriptionDetails}
          formDisabled={props.incidentNumber && !formType}
          resetValues={resetValues}
        />
        <CallerDetails
          isValid={setCallerDetailsValid}
          setCallerDetails={setCallerDetails}
          userType={props.userType}
          setButtonState={isSaveButtonDisabled}
          formDisabled={props.incidentNumber && !formType}
          resetValues={resetValues}
        />
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            id="cancelSearch"
            btnType="Cancel"
            clicked={clearSearch}
            attr={{ type: "button" }}
            disabled={props.incidentNumber && !formType}
          >
            Cancel
          </Button>
          <Button
            id="reportSearch"
            btnType="Search"
            disabled={props.incidentNumber && !formType}
          >
            Create Incident
          </Button>
        </div>
      </form>
    );
  };

  const inputChangedHandler = () => {};

  const searchForm = () => {
    return (
      <form onSubmit={createIncidentHandler}>
        <div style={{ display: "flex", flexFlow: "column", rowGap: "10px" }}>
          <div className={classes.formLayout}>
            <Input
              key={"quickSearchKeyword"}
              elementType={searchFormState["quickSearchKeyword"].elementType}
              elementConfig={
                searchFormState["quickSearchKeyword"].elementConfig
              }
              value={searchFormState["quickSearchKeyword"].value}
              invalid={!searchFormState["quickSearchKeyword"].valid}
              shouldValidate={searchFormState["quickSearchKeyword"].validation}
              touched={searchFormState["quickSearchKeyword"].touched}
              disabled={searchFormState["quickSearchKeyword"].disabled}
              label={searchFormState["quickSearchKeyword"].label}
              inputType={searchFormState["quickSearchKeyword"].inputType}
              changed={(event) =>
                inputChangedHandler(event, "quickSearchKeyword")
              }
            />
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Button
            id="cancelSearch"
            btnType="Cancel"
            clicked={clearSearch}
            attr={{ type: "button" }}
            disabled={props.incidentNumber && !formType}
          >
            Cancel
          </Button>
          <Button
            id="reportSearch"
            btnType="Search"
            disabled={props.incidentNumber && !formType}
          >
            Search Incident
          </Button>
        </div>
      </form>
    );
  };

  useEffect(() => {
    if (
      (!props.portalsList || !props.portalsList.length > 0) &&
      props.userType === SESSION_READONLYUSER
    ) {
      props.fetchPortals(props.sdkPortalList);
    }
    if (props.user.userType !== SESSION_SUPERUSER) {
      props.history.push("/search");
    }
    return () =>{
      props.resetIncidentMembersList([]);
      props.resetIncidentDetails();
    }
  }, []);

  // useEffect(() => {
  //   console.log("details", {
  //     reporterDetails,
  //     callerDetails,
  //     basicDetails,
  //     descriptionDetails,
  //   });
  // }, [reporterDetails, callerDetails, basicDetails, descriptionDetails]);

  useEffect(() => {
    if (props.formType === "details") {
      window.scrollTo({
        top: 0,
      });
    }
  }, [props.formType]);

  const getPageHeader = () => {
    switch (formType) {
      case "create":
        return CREATE_SERVICE_NOW;
      case "search":
        return SEARCH_SERVICE_NOW;
      case "edit":
        return EDIT_SERVICE_NOW;
      case "details":
        return DETAILS_SERVICE_NOW;
      default:
        return CREATE_SERVICE_NOW;
    }
  };
  return (
    <DisplayBox>
      <div className={classes.SearchWindow}>
        <div className={classes.headerContainer}>
          <h2 className={classes.FormTitle}>{getPageHeader()}</h2>
          <div className={classes.headerBtnContainer}>
            {props.incidentNumber && (
              <Button
                id="create"
                btnType="Search"
                clicked={() => {
                  props.resetIncidentDetails();
                  setResetValues(!resetValues);
                  props.resetIncidentMembersList([]);
                  // props.setFormType("create");
                }}
              >
                {"Create New Incident"}
              </Button>
            )}
          </div>
          {/* <div className={classes.headerBtnContainer}>
            {formType!=="create" && (
              <Button
                id="create"
                btnType="Search"
                clicked={() => {
                  props.resetIncidentDetails();
                  props.setFormType("create");
                }}
              >
                {"Create Incident"}
              </Button>
            )}
            {formType!=='search' && (
              <Button
                id="search"
                btnType="Search"
                clicked={() => {
                  props.setFormType("search");
                }}
              >
                {"Search Incident"}
              </Button>
            )}
            {!["edit", "create", "search"].includes(formType) && (
              <Button
                id="edit"
                btnType="Search"
                clicked={() => {
                  props.setFormType("edit");
                }}
              >
                {"Edit Incident"}
              </Button>
            )}
          </div> */}
        </div>
        {(message || props.apiErroMsg) && (
          <Message
            msgType={"Error"}
            info={{ message: message || props.apiErroMsg }}
          />
        )}
        {formType !== "search" && createForm()}
        {formType === "search" && searchForm()}
        {props.processing ? (
          <Modal show={props.processing}>
            <Spinner />
          </Modal>
        ) : null}
      </div>
    </DisplayBox>
  );
};

export const mapStateToProps = (state) => {
  return {
    member: state.member.member,
    memberEsso: state.member?.member?.essoData,
    portalsList: state.personalInfo.portals,
    portalsInfo: state.personalInfo.portalsInfo,
    processing: state.serviceNow.incidentProcessing,
    message: state.member.accountStatusMessage,
    deleteAccountMsg: state.member.deleteAccountMsg,
    deleteAccountStatus: state.member.deleteAccountStatus,
    sdkPortalList: state.member.sdkPortalList,
    searchResult: state.search.searchResults,
    user: state.usr.user,
    disabledPortals: state.addEligibility.disabledPortals,
    incidentMembersList: state.member?.incidentMembersList,
    incidentNumber: state.serviceNow.incidentNumber,
    apiErroMsg: state.serviceNow.apiErroMsg,
    formType: state.serviceNow.formType,
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    isReportSearched: (searched) =>
      dispatch(actions.isReportSearched(searched)),
    setError: (error) => dispatch(actions.setError(error)),
    fetchPortals: (sdkPortalList) =>
      dispatch(actions.fetchMemberAccountPortals(sdkPortalList)),
    resetIncidentDetails: () => dispatch(actions.resetIncidentDetails()),
    setFormType: (type) => dispatch(actions.setIncidentFormType(type)),
    resetIncidentMembersList: (data) => dispatch(actions.resetIncidentMembersList(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceNowContainer);
